import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useIsUIVisible } from "../../../VideoContextProvider/context/state/isUIVisible.js";
import { useIsReady } from "../../../VideoContextProvider/context/state/isReady.js";
import { useIsAdPlaying } from "../../../VideoContextProvider/context/state/isAdPlaying.js";
import { debug } from "../../../../log.js";
import { Backdrop } from "../Backdrop/index.js";
import { Scrubber } from "../Scrubber/index.js";
import { PlayPauseButton } from "../PlayPauseButton/index.js";
import { Rewind } from "../Rewind/index.js";
import { Volume } from "../Volume/index.js";
import { Time } from "../Time/index.js";
import { SubtitlesButton } from "../SubtitlesButton/index.js";
import { FullScreenButton } from "../FullScreenButton/index.js";
import { PipButton } from "../PipButton/index.js";
import { LiveButton } from "../LiveButton/index.js";
/* empty css           */
const debugRackWithDVR = debug.extend("rack-with-dvr");
function RackWithDVR({
  showPipButton = false,
  isVOD = false,
  onPipRequest,
  onFullScreenRequest
}) {
  const isUIVisible = useIsUIVisible();
  const isReady = useIsReady();
  const isAdPlaying = useIsAdPlaying();
  const isLiveAdPlaying = isAdPlaying && !isVOD;
  debugRackWithDVR(
    "### DEBUG OMEGA NPM: STEP 2 - RackWithDVR received onPipRequest:",
    !!onPipRequest
  );
  if (!isReady) {
    return null;
  }
  return /* @__PURE__ */jsxs(Fragment, { children: [
    /* @__PURE__ */jsx(Backdrop, {}),
    /* @__PURE__ */jsxs(
      "div",
      {
        className: classNames("omega_rackWithDVR", { "omega_rackWithDVR-show": isUIVisible }),
        "data-testid": "rack",
        children: [
        !isAdPlaying && /* @__PURE__ */jsx(Scrubber, {}),
        !isLiveAdPlaying && /* @__PURE__ */jsx(PlayPauseButton, {}),
        !isAdPlaying && /* @__PURE__ */jsx(Rewind, {}),
        /* @__PURE__ */jsx(Volume, {}),
        !isVOD && /* @__PURE__ */jsx(LiveButton, {}),
        /* @__PURE__ */jsx(Time, { isVOD }),
        /* @__PURE__ */jsx("div", {}),
        /* @__PURE__ */jsx(SubtitlesButton, { isVOD }),
        showPipButton && /* @__PURE__ */jsx(PipButton, { onPipRequest }),
        /* @__PURE__ */jsx(FullScreenButton, { onFullScreenRequest })]

      }
    )]
  });
}
export {
  RackWithDVR,
  RackWithDVR as default };
//# sourceMappingURL=dist/components/VideoContainer/VideoControlRack/RackWithDVR/index.js.map